var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgBellMessage = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 11,
    viewBox: "0 0 9 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.49962 0C4.14404 0 3.85676 0.287277 3.85676 0.642857V1.02857C2.39024 1.32589 1.28533 2.62366 1.28533 4.17857V4.55625C1.28533 5.50045 0.937785 6.4125 0.310999 7.11964L0.162339 7.28638C-0.00641132 7.47522 -0.0465899 7.74643 0.0558655 7.97746C0.158321 8.20848 0.389348 8.35714 0.642473 8.35714H8.35676C8.60988 8.35714 8.8389 8.20848 8.94337 7.97746C9.04783 7.74643 9.00564 7.47522 8.83689 7.28638L8.68823 7.11964C8.06145 6.4125 7.7139 5.50246 7.7139 4.55625V4.17857C7.7139 2.62366 6.60899 1.32589 5.14247 1.02857V0.642857C5.14247 0.287277 4.8552 0 4.49962 0ZM5.40966 9.91005C5.65073 9.66897 5.78533 9.34152 5.78533 9H4.49962H3.2139C3.2139 9.34152 3.3485 9.66897 3.58957 9.91005C3.83064 10.1511 4.1581 10.2857 4.49962 10.2857C4.84113 10.2857 5.16859 10.1511 5.40966 9.91005Z",
    fill: "#C0FF88"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgBellMessage);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/bell-message.f9c70aa320ee1074d40abd5aad909c8f.svg";